export default "__VITE_ASSET__DorIOaCz__"